import { replace } from 'connected-react-router';
import { buildLocationWithSecurity } from 'Utils/routing';
import pageRoutes from 'Constants/page-routes';

export const replaceToIndex = (customSecurityId) => (dispatch) => {
    const location = buildLocationWithSecurity(pageRoutes.index, customSecurityId);

    dispatch(replace(location));
};
